import logoImage from './../assets/images/versum-logo.png';
import {CLIENT_NAME, CLIENT_THEME} from "../utils/constants";
import APP_ENV from "../config/appEnv";

const config = {
    clientName: CLIENT_NAME.VERSUM_HEALTH,

    // theme
    theme: CLIENT_THEME.VERSUM_HEALTH,

    // header
    logo: logoImage,
    logoLink: APP_ENV.CLIENT_RETURN_URL,
    logoText: 'Versum Health',

    // entry form
    entryForm: {
        showReturn: true,
        showCancel: true,
    },

    // footer
    footer: {
        copyright: `© Versum Health, Inc 2024. All rights reserved.`,
        privacy: true,
        contact: true,
    }
}

export default config;
